import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useI18n } from "@/i18n";
import AdSlot from "./AdSlot";

export default function Footer() {
  const { settings } = useApp();
  const { t } = useI18n();
  const year = new Date().getFullYear();

  const links = [
    { to: "/about", label: t("about") },
    { to: "/faq", label: t("faq") },
    { to: "/learn", label: t("learning_library") },
    { to: "/contact", label: t("contact") },
    { to: "/privacy", label: t("privacy") },
    { to: "/terms", label: t("terms") },
  ];

  return (
    <footer className="mt-16 border-t border-border bg-card/30" data-testid="site-footer">
      <AdSlot slotKey="FOOTER" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-8">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-3">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-primary text-primary-foreground">
                <Zap className="w-4 h-4" fill="currentColor" />
              </span>
              <span className="font-head font-extrabold text-lg">
                {settings.site_name || "ARAN TOOLS"}
              </span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {settings.site_description || t("footer_tagline")}
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.to.slice(1)}`}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="mt-8 pt-6 border-t border-border/60 text-xs text-muted-foreground text-center">
          © {year} {settings.site_name || "ARAN TOOLS"} — {t("all_rights")}
        </div>
      </div>
    </footer>
  );
}
